// extracted by mini-css-extract-plugin
export default {"zoomControls":"afa-z","zoomControlButton":"bfa-z","zoomBanner":"cfa-z","bannerButton":"dfa-z","imageButton":"efa-z","zoom":"ffa-z","zoomContent":"gfa-z"};